export interface FloatingInitOptions {
    targetSelector: string;
    watchSelector: string;
    offset?: number;
    defaultBottom?: number;
}

/**
 * 漂浮工具列位置處理
 */
export const initFloating = ({
    targetSelector,
    watchSelector,
    offset = 16,
    defaultBottom = 75,
}: FloatingInitOptions): (() => void) | undefined => {
    const target = document.querySelector(targetSelector) as HTMLElement | null;
    if (!target) {
        return;
    }

    let resizeObserver: ResizeObserver | null = null;
    let currentWatch: Element | null = null;

    const updatePosition = (toolbar: HTMLElement | null): void => {
        if (!toolbar) {
            target.style.bottom = `${defaultBottom}px`;
            return;
        }

        const height = toolbar.offsetHeight;
        target.style.bottom = `${height + offset}px`;
    };

    const watchToolbar = (toolbar: Element | null): void => {
        if (resizeObserver && currentWatch) {
            resizeObserver.unobserve(currentWatch);
        }

        currentWatch = toolbar;

        if (toolbar instanceof HTMLElement) {
            resizeObserver = new ResizeObserver((entries) => {
                const currentEntry = entries[0];
                if (!currentEntry) {
                    return;
                }

                target.style.bottom = `${currentEntry.contentRect.height + offset}px`;
            });
            resizeObserver.observe(toolbar);
            updatePosition(toolbar);
            return;
        }

        updatePosition(null);
    };

    const detectToolbar = (): void => {
        const toolbar = document.querySelector(watchSelector);
        if (toolbar !== currentWatch) {
            watchToolbar(toolbar);
        }
    };

    detectToolbar();

    const mutationObserver = new MutationObserver(() => {
        detectToolbar();
    });
    mutationObserver.observe(document.body, {
        childList: true,
        subtree: true,
    });

    return () => {
        mutationObserver.disconnect();
        if (resizeObserver && currentWatch) {
            resizeObserver.unobserve(currentWatch);
        }
    };
};
